import { useSelector } from "react-redux";
import { Identifiable } from "../../app/models/Identifiable";
import { State } from "../../app/store";
import { getOtherAccountDisplayName } from "../otherAccountDisplayName";

export const useOtherAccountDisplayName = (itemAccount?: Identifiable | null): string | null => {
  const allowSubaccounts = useSelector((state: State) => state.config.configuration.allowSubaccounts === true);
  const userData = useSelector((state: State) => state.auth.userData);

  if (!allowSubaccounts) {
    return null;
  }

  return getOtherAccountDisplayName(itemAccount, userData);
};
